import React from 'react';

interface EnterpriseTextCmpProps {
  class_name: string;
  text_content: string;
}

function EnterpriseTextCmp({
  class_name,
  text_content,
}: EnterpriseTextCmpProps): React.ReactElement {
  return <div className={class_name}>{text_content}</div>;
}

export default EnterpriseTextCmp;
